// Saved-canvas client — the browser half of FE2a's GET/PUT /layouts. The store
// (canvas.ts) owns the live placements; this only talks to the backend: load a
// section's board on mount, save it on the Save button.

import type { LayoutBoard, LayoutSection, WidgetPlacement } from "@catbento/shared";
import { apiGet, apiSend } from "../api.js";

/** Load the caller's saved board for a section (never-saved → empty placements). */
export function loadLayout(section: LayoutSection): Promise<LayoutBoard> {
  return apiGet<LayoutBoard>(`/layouts?section=${section}`);
}

/** Upsert the caller's board for a section. */
export function saveLayout(
  section: LayoutSection,
  placements: WidgetPlacement[]
): Promise<LayoutBoard> {
  return apiSend<LayoutBoard>("PUT", `/layouts?section=${section}`, { placements });
}
